// extracted by mini-css-extract-plugin
module.exports = {"product":"_1Dt6JISC","image":"_236ZuYbh","title":"_2Pj-RoFl","price":"_1JWA-nA6","description":"cgIS-ESz","stock":"Jh3V_RFL","btnAdd":"_1MrtQp5S","siteWarning":"_3hRCYhK1"};